/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const SEARCH = {
  label: 'Search',
  route: '/chat',
};

export const CME = {
  label: 'CME',
  route: '/my-cme',
};

export const FAVORITES = {
  label: 'Favorites',
  route: '/favorites',
};

export const AFFILIATE_ADMIN = {
  label: 'Affiliate Admin',
  route: '/affiliateadmin',
};

export const CONSUMER_ADMIN = {
  label: 'Admin',
  route: '/admin/logs',
};
export const HOME = {
  label: 'Home',
  route: '/',
};

export const BROKEN_HEARTS = {
  label: 'Broken Hearts',
  route: '/admin/analysis',
};

export const MANAGE_REVIEWERS = {
  label: 'Manage Reviewers',
  route: '/admin/consultantReviewers',
};

export const VIEW_WIDGETS = {
  label: 'View Widgets',
  route: '/admin/widgets',
};

export const FEEDBACK_ADMIN = {
  label: 'Feedback Admin',
  route: '/admin/feedbackManagement',
};
export const ASSIGNED_TO_ME = {
  label: 'Assigned to me',
  route: '/doc?assignee',
};

export const QUICK_START_GUIDE = 'Quick Start Guide';

export const LOGOUT = 'Log Out';
export const FEEDBACK = 'Feedback';
export const CREATOR_FEEDBACK = 'Give Feedback';
export const TEST_ENV = 'Test Env';
